export class CancellationSubscriptionPlanOrderException {}